"use client";

import clsx from "clsx";

/**
 * Stylised browser chrome — used by Aurora's public catalogue page (Act 0.5)
 * to make it read as a real public web page rather than an in-product surface.
 */
export function BrowserFrame({
  url,
  children,
  className,
}: {
  url: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={clsx("glass flex h-full flex-col overflow-hidden", className)}>
      <div className="flex shrink-0 items-center gap-2 border-b border-state-verified/20 bg-orbitra-ink/80 px-3 py-2">
        <div className="flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-orbitra-muted/40" />
          <span className="h-2.5 w-2.5 rounded-full bg-orbitra-muted/40" />
          <span className="h-2.5 w-2.5 rounded-full bg-orbitra-muted/40" />
        </div>
        <div className="ms-3 flex flex-1 items-center gap-2 rounded-md border border-state-verified/20 bg-orbitra-ink/60 px-3 py-1 text-[11px] font-mono text-orbitra-teal-soft">
          <span className="text-state-verified">●</span>
          <span className="truncate">{url}</span>
        </div>
      </div>
      {/* Scrollable page body — long catalogue content (Seller Trust Profile +
          listing tiles + Submit-a-Proposal CTA) can exceed the scene-panel
          height on 16:10 projectors. flex-1 + overflow-y-auto makes the page
          read like a real browser tab. */}
      <div className="flex-1 overflow-y-auto bg-orbitra-ink/40">{children}</div>
    </div>
  );
}
